<div class="c-field-value--cell-with-label">
  <h4>{{ label }}</h4>
  <div class="c-field-value--cell-with-label__cell">
    <ng-container [ngSwitch]="type">
      <gtd-ui-field-default-string-whitespace-or-empty
        *ngSwitchCase="'string_with_label'"
        [data]="data"
      ></gtd-ui-field-default-string-whitespace-or-empty>
      <gtd-ui-field-special-conversion-tracking-type [data]="data" *ngSwitchCase="'conversion_tracking_type'">
      </gtd-ui-field-special-conversion-tracking-type>
      <gtd-ui-field-special-os-with-icon [data]="data" *ngSwitchCase="'os_with_label'"></gtd-ui-field-special-os-with-icon>

      <ng-container *ngSwitchDefault>
        <ng-content></ng-content>
      </ng-container>
    </ng-container>
  </div>
</div>
